import { render, staticRenderFns } from "./myface.vue?vue&type=template&id=6e3f0c40&scoped=true"
import script from "./myface.vue?vue&type=script&lang=js"
export * from "./myface.vue?vue&type=script&lang=js"
import style0 from "./myface.vue?vue&type=style&index=0&id=6e3f0c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3f0c40",
  null
  
)

export default component.exports